/* eslint-disable no-unused-expressions */
/* eslint-disable no-sequences */

export const numberWithCommas = (x) => {
  if (x !== undefined && x !== null) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return "-";
};

export const mapToObj = (inputMap) => {
  let obj = {};

  inputMap.forEach(function (value, key) {
    obj[key] = value;
  });

  return obj;
};

export function makeid(length) {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function adtitleValidation(val) {
  if (val.length > 50) {
    return "AD Title should only contain maximum of 50 characters.";
  } else if (val.length < 5) {
    return "AD Title should contain at least 5 characters.";
  } else {
    return "";
  }
}

export function adfileValidation(file) {
  var allowedExtensions = /(\.m4a|\.flac|\.mp3|\.wav|\.wma|\.aac)$/i;
  if (file.size > 10485760) {
    return "File Size cannot be more than 10MB";
  }

  if (!allowedExtensions.exec(file.name)) {
    return "Invalid file type. Please upload an audio file";
  }
  if (file.name.split(".").length > 2) {
    return "Wrong Format. Please Check the file name.";
  }

  return "";
}

export function adbudgetValidation(val, max, min) {
  if (isNaN(val)) {
    return "Please Enter Numbers";
  } else if (val > max) {
    return "AD Budget should be less than or equal to " + max.toString();
  } else if (val < min) {
    return "AD Budget should be greater than or equal to " + min.toString();
  } else {
    return "";
  }
}

export function adfrequencyValidation(val, max, min) {
  if (isNaN(val)) {
    return "Please Enter Numbers";
  } else if (val > max) {
    return "AD Frequency should be less than or equal to " + max.toString();
  } else if (val < min) {
    return "AD Frequency should be greater than or equal to " + min.toString();
  } else {
    return "";
  }
}

export function businessnameValidation(val) {
  if (val.length > 25) {
    return "Business Name should only contain maximum of 25 characters.";
  } else if (val.length < 5) {
    return "Business Name should contain at least 5 characters.";
  } else {
    return "";
  }
}

export function passwordValidation(val) {
  var paswd = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,25}$/;
  if (val.match(paswd)) {
    return "";
  } else {
    return "Password should be between 8 to 25 characters and should contain at least 1 digit and a special character";
  }
}

export function emailValidation(val) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (re.test(String(val).toLowerCase())) {
    return "";
  } else {
    return "Incorrect Email";
  }
}

export function fullnameValidation(val) {
  //const re = /
  const re = /^[a-zA-Z- ]+$/;
  if (re.test(String(val).toLowerCase())) {
    return "";
  } else {
    return "Enter a Proper Name";
  }
}

export function phonenumberValidation(val) {
  var phoneno = /^\+(?:[0-9]●?){11,13}[0-9]$/;
  if (val.match(phoneno)) {
    return "";
  } else {
    return "Please Enter Your Phone in +251911223344 format";
  }
}

export function addressValidaton(val) {
  if (val.length > 5) {
    return "";
  } else {
    return "Address should at least be 6 characters or more";
  }
}

export function bankaccoutValidation(val) {
  if (val.length > 5) {
    var bankno = /^\d+$/;
    if (val.match(bankno)) {
      return "";
    } else {
      return "Bank Account Number is not appropriate";
    }
  } else {
    return "Bank Account Number is not appropriate";
  }
}

// TEMP

// else if (
//   prev.region.adscheduleloading === false &&
//   this.props.region.adscheduleloading === false &&
//   prev.region.routeaverageloading === false &&
//   this.props.region.routeaverageloading === false &&
//   prev.region.destinationsloading === false &&
//   this.props.region.destinationsloading === false &&
//   prev.region.carmodelsloading === false &&
//   this.props.region.carmodelsloading === false &&
//   prev.region.timeslotsloapding === false &&
//   this.props.region.timeslotsloading === false &&
//   this.state.missingerror !== ""
// ) {
//   this.setState({
//     askchangeregion: false,
//     missingerror: "",
//   });
// }
